// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-button-like{align-self:inherit}.w-button-like .v-btn{position:relative;z-index:1}", ""]);
// Exports
module.exports = exports;
